<div class="modal-header">
  <div>
    <h3><b>{{SectionName}}</b></h3>
    <h5 class="modal-title">Traffic Light Settings</h5>
  </div>
  <div class="close-button">
    <button (click)="closeDialog()">X</button>
  </div>
</div>

<div class="modal-body">
  <form>
    <div *ngFor="let rule of trafficLightRules; let i = index" class="row align-items-center mb-3">
      <!-- Icon Picker -->
      <div class="col-1">
        <div class="icon-box" [ngStyle]="{'background-color': rule.Color}">
        </div>
      </div>

      <div class="col-md-3">
        <p *ngIf="i === 0">when value is</p>
        <p *ngIf="i === 1">
          when > {{ trafficLightRules[0]?.ThresholdValue !== null && trafficLightRules[0]?.ThresholdValue !== undefined
          ? trafficLightRules[0]?.ThresholdValue : '...' }} and
        </p>
        <p *ngIf="i === 2">when value is</p>
      </div>

      <!-- Condition -->
      <ng-container>
        <div class="col-md-2">
          <select [(ngModel)]="rule.Operator" name="op-{{i}}" class="form-control">
            <option value=">=">>=</option>
            <option value="<">
              < </option>
            <option value="<=">
              <= </option>
            <option value=">">></option>
            <option value="==">==</option>
          </select>
        </div>

        <div class="col-md-2">
          <input type="number" [(ngModel)]="rule.ThresholdValue" name="val-{{i}}" class="form-control mt-1">
        </div>

        <!-- Type -->
        <!-- <div class="col-2">
          <select [(ngModel)]="rule.type" name="type-{{i}}" class="form-control">
            <option value="Percent">Percent</option>
            <option value="Number">Number</option>
          </select>
        </div> -->
      </ng-container>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button class="btn btn-primary" (click)="save()">Save</button>
</div>